import axios from "axios";

export default axios.create({
  baseURL: "https://o45a2u2kfk.execute-api.sa-east-1.amazonaws.com/items",
  headers: {
    "Content-type": "application/json",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
  }
});